<ion-header no-border mode="md">
  <ion-toolbar class="top-color" mode="md" title-with-slogan>
    <ion-title>
      <h2>
        <ion-text color="primary">
          {{ 'manageQuestionGroup.title' | translate }}
        </ion-text>
      </h2>
      <p>
        {{ 'manageQuestionGroup.subtitle' | translate | uppercase }} |
        <span class="lang-selection">
          <ion-button fill="clear" mode="ios" class="ion-no-padding"
            (click)="changeSelectedLanguage('pt-BR')"
            [ngClass]="{ 'active': language === 'pt-BR' }" >
            PT
          </ion-button>
          <ion-button fill="clear" mode="ios" class="ion-no-padding"
            (click)="changeSelectedLanguage('en-US')"
            [ngClass]="{ 'active': language === 'en-US' }" >
            EN
          </ion-button>
          <ion-button fill="clear" mode="ios" class="ion-no-padding"
            (click)="changeSelectedLanguage('es-ES')"
            [ngClass]="{ 'active': language === 'es-ES' }" >
            ES
          </ion-button>
        </span>
      </p>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="primary" (click)="dismiss()" mode="ios">
        <ion-icon class="bp-close" name="delete" ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    
  <div class="define-the-names">
    <!-- <h4>{{ 'manageQuestionGroup.manageInstructions' | translate }}</h4> -->

    <form class="form" [formGroup]="form" (ngSubmit)="save()">
      <ion-row llrm>
        <ion-col size="12" size-md="12">
          <ion-item *ngIf="language === 'pt-BR'">
              <ion-label position="stacked">
                {{ 'manageQuestionGroup.nameLabel' | translate }} <span style="color: var(--ion-color-danger)"><span  *ngIf="form.get('name').touched && form.get('name').invalid">({{'generic.required' | translate}})</span><span>*</span></span>   
              </ion-label>
              <ion-input type="text"
                formControlName="name"
                [placeholder]="'manageQuestionGroup.namePlaceholder' | translate">
              </ion-input>
          </ion-item>
          <ion-item *ngIf="language === 'en-US'">
              <ion-label position="stacked">
                {{ 'manageQuestionGroup.nameLabel' | translate }} <span style="color: var(--ion-color-danger)"><span  *ngIf="form.get('name').touched && form.get('name').invalid">({{'generic.required' | translate}})</span><span>*</span></span>   
              </ion-label>
              <ion-input type="text"
                formControlName="nameEN"
                [placeholder]="'manageQuestionGroup.namePlaceholder' | translate">
              </ion-input>
          </ion-item>
          <ion-item *ngIf="language === 'es-ES'">
            <ion-label position="stacked">
              {{ 'manageQuestionGroup.nameLabel' | translate }} <span style="color: var(--ion-color-danger)"><span  *ngIf="form.get('name').touched && form.get('name').invalid">({{'generic.required' | translate}})</span><span>*</span></span>   
            </ion-label>
            <ion-input type="text"
              formControlName="nameES"
              [placeholder]="'manageQuestionGroup.namePlaceholder' | translate">
            </ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" size-md="12">
          <ion-item>
              <ion-label position="stacked">
                {{'manageQuestionGroup.showOnCalibration' | translate }}
              </ion-label>
              <ion-checkbox formControlName="showOnCalibration" custom-checkbox slot="end" mode="ios"></ion-checkbox>
          </ion-item>
          <!-- <ion-label>
              {{'manageQuestionGroup.showOnCalibration' | translate }}
            </ion-label>
          <ion-checkbox formControlName="showOnCalibration" custom-checkbox mode="ios"></ion-checkbox> -->
        </ion-col>
      </ion-row>
    </form>
  </div>
</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios">
    <ion-row>
      <ion-col hidden-mobile>
      </ion-col>
      <ion-col size-md="4">
        <ion-button color="secondary" expand="block" mode="ios"
          (click)="save()" >
          {{ 'generic.save' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>